import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import TextInput from "../../form/TextInput";
import Select from "../../form/Select";
import {PartnerSelect} from "../../../utils/formatters";

class RoyaltyLicensorForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-10">
                        <Select
                            objectValue={false}
                            name="partner_id"
                            component="partner"
                            labelKey="name"
                            storeType="remote"
                            optionsTemplate={PartnerSelect}
                            value={this.props.values.partner_id}
                            saveChanges={this.props.setFieldValue}
                            label="Partner"
                            {...this.props.getFieldProps("partner")}
                            disabled={this.props.values[this.props.componentConfig.idfield]}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <TextInput
                            name="report_email"
                            value={this.props.values.report_email}
                            saveChanges={this.props.setFieldValue}
                            label="Email"
                            {...this.props.getFieldProps("report_email")}
                        />
                    </div>
                    <div className="col-sm-4">
                        <TextInput
                            name="report_template"
                            value={this.props.values.report_template}
                            saveChanges={this.props.setFieldValue}
                            label="Template"
                            {...this.props.getFieldProps("report_template")}
                        />
                    </div>
                    <div className="col-sm-4">
                        <TextInput
                            type="number"
                            name="report_frequency"
                            value={this.props.values.report_frequency}
                            saveChanges={this.props.setFieldValue}
                            formatter={(value) => (value || "-") + " Havonta"}
                            label="Periódus"
                            {...this.props.getFieldProps("report_frequency")}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(RoyaltyLicensorForm);
